export default __webpack_public_path__ + "static/media/icon_facet_line.4ef7c0c9.svg";